import { useQuery } from "@tanstack/react-query";
import apiClient from "../lib/apiClient";
import { useParams } from "react-router-dom";

export const useTanstack = (name, withLanguage = true) => {
    const { language } = useParams();

    return useQuery({
        queryKey: withLanguage ? [name, language] : [name],
        queryFn: async () => {
            const url = withLanguage ? `/${name}/${language}` : `/${name}`;
            const { data } = await apiClient.get(url);
            return data;
        },
        enabled: withLanguage ? !!language : true,
        // staleTime: Infinity,
        // refetchOnWindowFocus: true,
        // refetchOnMount: true,
    });
};

export const useTanstackById = (name, idFromArgs) => {
    const { id: idFromParams, language } = useParams();

    // after adding news in dynamic routes remove id from args
    const id = idFromArgs || idFromParams;

    return useQuery({
        queryKey: [`${name}ById`, id, language],
        queryFn: async () => {
            const { data } = await apiClient.get(`/${name}/${id}/${language}`);
            return data;
        },
        // staleTime: 0,
        // staleTime: Infinity,
        // refetchOnWindowFocus: true,
        // refetchOnMount: true,
    });
};

// export const useTanstackByParams = ({ name, ...params }) => {
//     return useQuery({
//         queryKey: [name, params],
//         queryFn: async () => {
//             const searchParams = new URLSearchParams();

//             Object.entries(params).forEach(([key, value]) => {
//                 if (value !== undefined && value !== null && value !== "") {
//                     searchParams.append(key, value);
//                 }
//             });

//             const queryString = searchParams.toString();
//             const url = `/${name}${queryString ? `?${queryString}` : ""}`;

//             const { data } = await apiClient.get(url);
//             return data;
//         },
//         staleTime: params?.startTime ?? Infinity,
//         refetchOnWindowFocus: false,
//         refetchOnMount: false,
//     });
// };